import constants from "../constants";
import AngleRightSvg from "../Svg/AngleRightSvg";
import AlertContext from "../context/AlertContext";
import "react-dropdown-tree-select/dist/styles.css";
import React, { useContext, useEffect } from "react";
import BreadCrumbsHooks from "../Hooks/BreadCrumbsHooks";
import StudentListHooks from "../Hooks/StudentListHooks";
import DropdownTreeSelect from "react-dropdown-tree-select";
import CodingViewHooks from "../Hooks/CodingPage/CodingViewHooks";
import MultiLevelDropDownHooks from "../Hooks/MultiLevelDropDownHooks";
import StudentTestAdminHooks from "../Hooks/StudentTestPage/StudentTestAdminHooks";
import { getDataFromStorage } from "../util";

export default function MultiLevelDropDown() {
  const Alert = useContext(AlertContext);

  const { viewCode } = CodingViewHooks();
  const { handleMcq } = StudentTestAdminHooks();
  const { getStudentList } = StudentListHooks();

  const { getCurrentPageDetails, getCurrentQuestionIdForCurrentLearner } =
    BreadCrumbsHooks();

  const { generateBreadCrumbsData, generateBreadCrumbsDataForLearnerSide } =
    MultiLevelDropDownHooks();

  const handleChange = (currentNode, selectedNodes) => {
    currentNode.value.from = Alert.showBreadCrumbsData.from;

    let showBreadCrumbsData = currentNode.value;

    if (Alert.isAdmin || Alert.showBreadCrumbsData.from === "learner") {
      if (
        showBreadCrumbsData.type === constants.libTypeIds.ASSIGNMENT ||
        showBreadCrumbsData.type === constants.libTypeIds.CODING_CHALLENGE
      ) {
        console.log("show..................", showBreadCrumbsData);
        if (
          [
            constants.QUESTION_STATUS.SUBMITTED,
            constants.QUESTION_STATUS.TO_BE_EVALUATED,
          ].includes(showBreadCrumbsData.status) ||
          Alert.isAdmin
        )
          getCurrentPageDetails(showBreadCrumbsData);
        else {
          Alert.setShowNotify({
            show: true,
            msg: `You haven't submitted the ${
              showBreadCrumbsData.type === constants.libTypeIds.ASSIGNMENT
                ? "assignment"
                : "question"
            } yet!. Please submit before the deadline.`,
            title: "Warning !",
          });
          return;
        }
      } else {
        getStudentList(showBreadCrumbsData);
        console.log("showBreadCrumbsData", showBreadCrumbsData);
        if (
          [
            constants.PROGRESS_STATUS.EVALUATED,
            constants.PROGRESS_STATUS.TO_BE_EVALUATED,
          ].includes(showBreadCrumbsData.status) ||
          Alert.isAdmin
        )
          handleMcq(
            showBreadCrumbsData.testId,
            showBreadCrumbsData.lpId,
            showBreadCrumbsData.lpConfigId,
            showBreadCrumbsData.status,
            showBreadCrumbsData.learnerId,
            showBreadCrumbsData.proctored,
            showBreadCrumbsData.testMode,
            showBreadCrumbsData.configData,
            [],
            true,
            showBreadCrumbsData,
            showBreadCrumbsData.type
          );
        else {
          Alert.setShowNotify({
            show: true,
            msg: `You haven't submitted the test yet!. Please submit before the deadline.`,
            title: "Warning !",
          });
          return;
        }
      }
    } else {
      viewCode(
        showBreadCrumbsData.test,
        "single",
        showBreadCrumbsData.questions
      );
    }
    Alert.setShowBreadCrumbsData(showBreadCrumbsData);
  };

  useEffect(() => {
    if (
      (Alert.isFromProfile.current ||
        getDataFromStorage("role") === "customer" ||
        Alert.showBreadCrumbsData.from === "learner" ||
        (Alert.isAdmin && !Alert.isFromProfile.current)) &&
      Alert.breadCrumbsData !== null &&
      Alert.breadCrumbsData !== undefined &&
      Alert.breadCrumbsData.length !== 0
    ) {
      generateBreadCrumbsData();

      if (Alert.showBreadCrumbsData.component === "studentList") {
        getCurrentQuestionIdForCurrentLearner();
      }
    } else {
      if (Alert.breadCrumbsData !== undefined && Alert.breadCrumbsData !== null)
        generateBreadCrumbsDataForLearnerSide();
    }
  }, [Alert.isAdmin, Alert.breadCrumbsData]);

  return (
    <div
      className={
        Alert.isAdmin || Alert.showBreadCrumbsData.from === "learner"
          ? "multiLevelDropDownContainer"
          : "multiLevelDropDownContainerForLearner"
      }
    >
      <DropdownTreeSelect
        onChange={handleChange}
        data={Alert.breadCrumbsOption}
        texts={{
          placeholder:
            Alert.isAdmin || Alert.showBreadCrumbsData.from === "learner"
              ? Alert.showBreadCrumbsData.moduleName
              : Alert.showBreadCrumbsData.topicName,
        }}
      />
      <AngleRightSvg component="codingPageLearnerSideBreadCrumbs" />
      <div className="multiLevelDropDownBreadCrumbsDiv">
        <div title={Alert.showBreadCrumbsData.testName}>
          {Alert.showBreadCrumbsData.testName}
        </div>
        {Alert.showBreadCrumbsData.type ===
          constants.libTypeIds.CODING_CHALLENGE && (
          <>
            {(Alert.isAdmin ||
              Alert.showBreadCrumbsData.from === "learner") && (
              <>
                <AngleRightSvg component="codingPageLearnerSideBreadCrumbs" />
                <div title={Alert.showBreadCrumbsData.topicName}>
                  {Alert.showBreadCrumbsData.topicName}
                </div>
                <AngleRightSvg component="codingPageLearnerSideBreadCrumbs" />
              </>
            )}
            <div title={"Question " + Alert.showBreadCrumbsData.questionNo}>
              Question {Alert.showBreadCrumbsData.questionNo}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
